import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import DataGrid from '../../OurModules/DataGrid/src/index.js';
import moment from 'moment-timezone';
import * as FileSaver from 'file-saver';
import { PageTemplate } from "../common/PageTemplate";

/**
 * Container component for the pharmacy page.
 * 
 */
class Claims extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            showLoader: true,
            claimsList: [],
            shouldRetrieveData: true,
            dateRange: localStorage.getItem('claimsDateRange')
                ? JSON.parse(localStorage.getItem('claimsDateRange'))
                : { from: moment().subtract(1, "months").format("MM/DD/YYYY"), to: moment().format("MM/DD/YYYY") }
        };
        this.goToDetails = this.goToDetails.bind(this);
        this.addRelationshipToData = this.addRelationshipToData.bind(this);
        this.addCSSClass = this.addCSSClass.bind(this);
        this.assignCSSClass = this.assignCSSClass.bind(this);
        //this.queueEOBDownload = this.queueEOBDownload.bind(this);
        this.openAppeal = this.openAppeal.bind(this);
        this.dateChanged = this.dateChanged.bind(this);
        this.getClaimsList = this.getClaimsList.bind(this);
    }

    componentDidMount() {
        //this.props.getClaims();
        //this.props.getMembersList();
        this.componentDidUpdate(this.props);
        logUI("MBHWeb.UI.ClaimsList.ComponentDidMount", new Date(), Tools.getURLPath());
    }    

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, AA, swhp} = this.props;
        if (this.props.claimsList !== prevProps.claimsList || this.props.membersList !== prevProps.membersList) {
            if (this.props.claimsList && this.props.membersList) {
                let claims = this.props.claimsList;
                claims = this.addCSSClass(claims);
                claims = this.addRelationshipToData(claims, this.props.membersList);
                this.setState({ claimsList: claims && claims.length > 0 ? claims : [], showLoader: false});
            }
        }
        if ((this.props.eobDocument !== prevProps.eobDocument || this.props.error !== prevProps.error) && this.props.claimsList) {
            this.handleEOBDownload();
        }
        if ((AA || hpIdentity || swhp) && this.state.shouldRetrieveData && !isFetching) {
            this.setState({ shouldRetrieveData: false });
            this.getClaimsList();
            this.props.getMembersList();
        }
    }

    getClaimsList() {
        let from, to;
        from = moment(this.state.dateRange.from).format("MM/DD/YYYY");
        to = moment(this.state.dateRange.to).format("MM/DD/YYYY");
        this.setState({ showLoader: true }, () => this.props.getClaims(from, to));
    }

    goToDetails(e) {
        this.props.history.push(`/claimdetail`, { claimId: e.ClaimID, claimType: e.ClaimType, memberNumber: e.MemberNumber, isEOBAvailable: e.IsEOBAvailable});
    }

    addRelationshipToData(claims, membersList) {
        if (!claims || claims.length === 0 || !membersList || membersList.length === 0) {
            return claims;
        }
        claims.map((claim) => {
            let match = membersList.find(member => member.MemberDisplayNbr === claim.MemberNumber);
            return claim.Relationship = match ? match.RelationshipToSubscriber : "";
        });
        return claims;
    }

    addCSSClass(claims) {
        if (!claims || claims.length === 0) {
            return claims;
        }

        claims.map((claim) => {
            return claim.statusClass = this.assignCSSClass(claim.ClaimStatus);
        });

        return claims;
    }

    assignCSSClass(status) {
        switch (status.toUpperCase()) {
            case "PROCESSED":
            case "PAY":
            case "APPROVED":
                return "claim-approved";
            case "CLOSED":
                return "claim-closed";
            case "ENTERED":
                return "claim-entered";
            case "IN ADJUDICATION":
                return "claim-in-adjudication";
            case "OVERPAY":
                return "claim-overpay";
            case "PENDING":
            case "PEND":
            case "IN PROCESS":
                return "claim-pending";
            case "DENIED":
            case "DENY":
            case "REJECT":
            case "REJECTED":
                return "claim-reject";
            default:
                return "";
        }

        return "";
    }

    //queueEOBDownload(data) {
    //    if (data.ClaimID) this.props.getEOBDocument(data.ClaimID);
    //    else console.log('no claim id present', data);
    //}

    handleEOBDownload() {
        if (this.props.error || !this.props.eobDocument || this.props.eobDocument.status === 204) {
            //this.setState({ showEobErrorMessage: true });
            return;
        }

        FileSaver.saveAs(this.props.eobDocument, "Explanation of Benefits.pdf");
    }

    openAppeal(e) {
        this.props.history.push(`/claimappeal`, { claimId: e.ClaimID});
    }

    dateChanged(filterType, data) {
        if (filterType === "date") {
            const fromDate = moment(data.dateRange.from).format("MM/DD/YYYY");
            const toDate = moment(data.dateRange.to).format("MM/DD/YYYY");
            const dateRangeObj = {
                from: fromDate,
                to: toDate,
                expire: "ONLOGOUT"
            }
            localStorage.setItem("claimsDateRange", JSON.stringify(dateRangeObj));
            this.setState({ dateRange: data.dateRange }, () => this.getClaimsList());
        }
    }

    claimsSubTitleMessage() {
        return (false) //always returning false for now, in case we need a message again sometime
            ? <div className='subtitle-message'></div>
            : null;
    }

    render() {
        var columnMetadata = [
            {
                type: "date",
                title: "Date of Service",
                value: "DateOfService",
                allowSorting: true
            },
            {
                type: "string",
                title: "Member",
                value: "MemberFirstName",
                allowSorting: true,
                subtextValue: "Relationship",
                subtextType: "string"
            },
            {
                type: "string",
                title: "Number",
                value: "ClaimDisplayNumber",
                allowSorting: true,
                hideOnTablet: true,
                //clickCallback: this.queueEOBDownload
            },
            {
                type: "string",
                title: "Provider",
                value: "ProviderName",
                allowSorting: true
            },
            {
                type: "string",
                title: "Status",
                value: "ClaimStatus",
                allowSorting: true,
                customCSSMapToValue: "statusClass"
            },
            {
                type: "currency",
                showEmptyIfNull: true,
                title: "You May Owe",
                value: "YouMayOwe",
                allowSorting: true
                //alignTextRight: true
            }//,
            //{
            //    type: "string",
            //    allowSorting: false,
            //    title: "Appeal",
            //    value: "",
            //    clickCallback: this.openAppeal,
            //    staticContent: "Appeal",
            //    excludeFromExport: true
            //}
        ]
        var gridMetadata = {
            title: "",
            selectable: true,
            enableFilters: true,
            filters: [{ filterName: "Member", dataKeyToUse: "MemberFirstName" }, { filterName: "Claim Type", dataKeyToUse: "ClaimType" }, { filterName: "Provider", dataKeyToUse: "ProviderName" }],
            initialDate: this.state.dateRange,
            searchFields: ["Member", "ClaimDisplayNumber", "ProviderName"],
            searchPlaceholder: "Search by claim #, provider, or member",
            dateField: "DateOfService",
            enableExport: true,
            enableSearch: true,
            enableDateRange: true,
            exportFormats: ["xls", "pdf"],
            exportName: "Claims",
            sortingEnabled: true,
            pagination: false, //not implemented
            rowsPerPage: 10, //not implemented
            rowClick: this.goToDetails,
            filterCallback: this.dateChanged,
            stopDateFilterPropogation: true, //stops date filtering and only runs specified callback, useful for making api calls that filter date
            columns: columnMetadata
        }
        return (
            <PageTemplate objectName='claims' pageTitle='Claims' >
                {this.claimsSubTitleMessage()}
                <DataGrid id="claims-data-grid" dataSource={this.state.claimsList} gridOptions={gridMetadata} showLoader={this.state.showLoader}></DataGrid>
            </PageTemplate>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        claimsList: state.healthPlanServices.claims,
        membersList: state.healthPlanServices.membersList,
        eobDocument: state.healthPlanServices.eobDocument,
        hpIdentity: state.session.healthPlanUserProfile,
        isFetching: state.healthPlanServices.isFetching,
        AA: state.domain.aai,
        swhp: state.domain.hi,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getClaims: (startDate, endDate) => dispatch({ type: types.HP_GET_CLAIMS_LIST_START, startDate: startDate, endDate: endDate }),
        getMembersList: () => dispatch({ type: types.HP_GET_MEMBERS_LIST_START }),
        getEOBDocument: (claimId) => dispatch({ type: types.HP_GET_EOB_DOCUMENT_START, claimId: claimId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Claims));
